import React from "react";

const Combo = () => {
    return (
      <React.Fragment>
          <div>Combo</div>
      </React.Fragment>
    );
  };
  
  export default Combo;